import { render } from "./exchangeCardFooter.vue?vue&type=template&id=46a361ea&scoped=true&lang=pug"
import script from "./exchangeCardFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./exchangeCardFooter.vue?vue&type=script&setup=true&lang=js"

import "./exchangeCardFooter.vue?vue&type=style&index=0&id=46a361ea&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a361ea"]])

export default __exports__